import { createSelector } from 'reselect'
import getItemByVariantIdCartSelector from 'modules/cart/redux/selectors/get-item-by-variant-id'
import hasVariantByIdInCartSelectorUtil from 'modules/cart/redux/selectors/has-variant-by-id-in-cart/utils'

const hasVariantByIdInCartSelector = variantId => createSelector(
  getItemByVariantIdCartSelector(variantId),
  (cartItem) => hasVariantByIdInCartSelectorUtil({
    cartItem
  })
)

export default hasVariantByIdInCartSelector
